import { selectUser } from '../../slices/global/authSlice';
import { Stack, Alert, AlertTitle, Typography } from '@mui/material';
import { useAppSelector } from '../../hooks';
import moment from 'moment';
import DashboardContent from './DashboardContent';
import RestrictedAccess from '../../components/RestrictedAccess';
import RefreshAll from './DashboardContent/RefreshAll';
import HelpWithInstructions from '../../components/HelpWithInstructions';

export default function Dashboard() {
  const user = useAppSelector(selectUser);
  const hour = moment().hour();

  return (
    <Stack>
      {user ? (
        <>
          <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="space-between">
            <Typography variant="h6">
              {`Good ${(hour < 12 && 'morning') || (hour < 18 && 'afternoon') || 'evening'}, ${
                user.profile['given_name']
              }.`}
            </Typography>
            <Stack direction="row">
              <RefreshAll />
              <HelpWithInstructions />
            </Stack>
          </Stack>
          <RestrictedAccess type="UI-Access" value="Dashboard Content" showAlert={false}>
            <DashboardContent />
          </RestrictedAccess>
        </>
      ) : (
        <Alert severity="warning" variant="outlined">
          <AlertTitle>Warning</AlertTitle>
          You must be logged in to view this content.
        </Alert>
      )}
    </Stack>
  );
}
